import type { Edit, Edits } from '../utils';
import type { LegacyUserContribution, LegacyUserContributions } from './types';

/**
 * Converts Legacy UserContributions to Hive Edits
 */
export function legacyUserContributionsToEdits(
    legacyUserContributions: LegacyUserContributions
): Edits {
    return Object.fromEntries(
        Object.entries(legacyUserContributions).map(([userId, legacyUserContribution]) => {
            return [userId, legacyUserContributionToEdit(legacyUserContribution)];
        })
    );
}

/**
 * Converts a Legacy UserContribution to a Hive Edit
 */
export function legacyUserContributionToEdit(legacyUserContribution: LegacyUserContribution): Edit {
    const updatedAtDate =
        legacyUserContribution.updatedAt instanceof Date
            ? legacyUserContribution.updatedAt
            : legacyUserContribution.updatedAt.toDate();

    return {
        count: legacyUserContribution.count,
        // In Hive Timestamps are simply stored as ms numbers
        updatedAt: updatedAtDate.getTime(),
    };
}

/**
 * Converts Hive Edits to Legacy UserContributions
 */
export function editsToLegacyUserContributions(edits: Edits): LegacyUserContributions {
    return Object.fromEntries(
        Object.entries(edits).map(([page, edit]) => {
            return [page, editToLegacyUserContribution(edit)];
        })
    );
}

/**
 * Converts an Edit to a Legacy UserContribution
 */
export function editToLegacyUserContribution(edit: Edit): LegacyUserContribution {
    return {
        count: edit.count,
        // In firestore updatedAt is stored as a Date
        updatedAt: new Date(edit.updatedAt),
    };
}
